import { DestroyRef, Directive, OnInit, Optional, Self } from "@angular/core";
import { AbstractControl, FormControlDirective, FormGroupDirective } from "@angular/forms";
import { CommonDataService } from "../services/common-data.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CONSTANTS } from "../Constants/Constants";
import { distinctUntilChanged } from "rxjs";

@Directive({
    selector: '[trackChanges]',
    standalone: true
})
export class TrackChangesDirective implements OnInit {

    private control: AbstractControl | null = null;
    constructor(
        @Optional() @Self() private readonly formGroupDirective: FormGroupDirective,
        @Optional() @Self() private readonly formControlDirective: FormControlDirective,
        private readonly commonDataService: CommonDataService,
        private readonly destroyRef: DestroyRef
    ) { }

    ngOnInit() {
        this.control = this.resolveControl();
        if (!this.control) {
            console.warn('TrackChangesDirective: No FormControl or FormGroup found.');
            return;
        }
        this.control.valueChanges.pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            const estimateId = this.commonDataService.getEstimateId();
            const isEstimateOpen = !!estimateId && estimateId !== CONSTANTS.DEFAULT_ESTIMATE_ID;
            if (isEstimateOpen && this.control.dirty) {
                this.commonDataService.isSaveEnabled = true;
            }
        });
    }

    private resolveControl(): AbstractControl | null {
        if (this.formControlDirective) {
            return this.formControlDirective.control;
        }
        if (this.formGroupDirective) {
            return this.formGroupDirective.control;
        }
        return null;
    }
}